<template>
	<div style="height: 100vh" class="responsive-note">
		<h3 class="mt-12 font-weight-black">Editar Url</h3>
		<v-card class="mt-5 d-flex align-start" width="1219" height="130">
			<div class="rounded borderGreen" style="height: 120px; width: 3px !important; background-color: var(--green); margin: 5px"></div>
			<div class="">
				<span class="font-weight-black pt-6 pl-10 d-flex flex-column" style="font-size: 14px">Url</span>
				<span class="d-flex align-center">
					<input
						placeholder="Insire a URL curta aqui."
						v-model="urlLong"
						class="mt-3 pl-2 responsive-input-long" 
						style="border: 2px solid var(--grey-day-020); height: 48px; width: 900px; margin-left: 40px; margin-right: 20px; border-radius: 4px"
					>
					<v-btn
						width="226"
						height="48"
						class="mt-2"
						depressed
						:disabled="urlLong === ''"
						:style="
							urlLong !== '' ? 'background: var(--red); color: var(--white)' : 'background: var(--white); color: var(--black)'"
						@click="getLongUrl"
					>
						<img :src="urlLong === '' ? '../../../../static/images/search_grey.svg' : '../../../../static/images/search.svg'"/>
						<span class="pl-3 ff">Buscar Url</span>
					</v-btn>
				</span>
			</div>
		</v-card>


			<h3 v-if="openEdit" class="mt-12 font-weight-black">Resultado</h3>
		<transition name="slide">
			<v-card v-if="openEdit" class="mt-13 d-flex align-start" width="1219" height="386">
				<div class="rounded borderGreen" style="height: 376px; width: 3px !important; background-color: var(--blue); margin: 5px"></div>
				<div class="d-flex flex-column">
					<span class="font-weight-black pt-7 pl-10 d-flex flex-column" style="font-size: 14px">Url Curta</span>
					<span class="d-flex align-center">
						<input
							v-model="this.url.shortUrl"
							class="mt-3 d-flex align-center pa-5 responsive-input"
							style="border: 2px solid var(--grey-day-020); height: 48px; width: 1115px; margin-left: 40px; margin-right: 20px; border-radius: 4px; background: var(--grey-day-020)"
						/>
					</span>
					<span class="font-weight-black pt-4 pl-10 d-flex flex-column" style="font-size: 14px">Url Longa Atual</span>
					<span class="d-flex align-center">
						<input
							v-model="this.url.longUrl"
							class="mt-3 d-flex align-center pa-5 responsive-input"
							style="border: 2px solid var(--grey-day-020); height: 48px; width: 1115px; margin-left: 40px; margin-right: 20px; border-radius: 4px; background: var(--grey-day-020)"
						/>
					</span>
					<span class="font-weight-black pt-4 pl-10 d-flex flex-column" style="font-size: 14px">Nova Url Longa</span>
					<span class="d-flex align-center">
						<input
							v-model="newUrl"
							class="mt-3 d-flex align-center pa-5 responsive-input"
							style="border: 2px solid var(--grey-day-020); height: 48px; width: 1115px; margin-left: 40px; margin-right: 20px; border-radius: 4px;"
						/>
					</span>
					<v-btn
						class="mt-4 ml-10"
						width="107"
						height="48"
						depressed
						@click="sendUpdateUrl"
						:color="newUrl ? 'var(--red)' : ''"
						:disabled="disabled"
					>
						<img :src="newUrl === '' ? '../../../../static/images/edit_grey.svg' : '../../../../static/images/edit_white.svg'"/><span style="color: grey; padding-right: 2px" :style="newUrl ? 'color: var(--white)' : ''">Salvar</span>
					</v-btn>
				</div>
			</v-card>
		</transition>
	</div>
</template>
<script>
// Lib
import { mapState, mapActions, mapMutations } from 'vuex'

import VueCookies from 'vue-cookies'

export default {
	data () {
		return {
			urlLong: '',
			newUrl: '',
			longUrl: '',
			openEdit: false,
			disabled: false
		}
	},
	computed: {
		...mapState('UrlTools', {
			url: 'url',
		}),
	},
	methods: {
		...mapActions('UrlTools',{
			getUrlLongEdit: 'getUrlLongEdit',
			updateUrlEdit: 'updateUrlEdit'
		}),
		...mapMutations('UrlTools', {
			setUrl: 'SET_URL',
			setUpdate: 'SET_URL_UPDATE'
		}),
		...mapMutations('Shared', {
      setToaster: 'SET_TOASTER'
    }),
		async getLongUrl () {
			const token = VueCookies.get('jwt-login')
			this.setUrl(this.urlLong)
			try {
				const urlLongWhiteSpace = this.urlLong.split(' ')
				if (urlLongWhiteSpace.length > 1) {
					this.toaster(
						'URL contém espaço em branco',
						'var(--red)',
						true
					)
					return 
				} else {
					const response = await this.getUrlLongEdit({token})
					this.openEdit = true
					this.disabled = true
					if (response.status >= 400) {
						throw new Error(response.data.message)
					}
				}
			} catch (e) {
				this.openEdit = false
        this.toaster(
					'URL não econtrada',
					'var(--red)',
					true
				)
      }
		},
		async sendUpdateUrl () {
			const token = VueCookies.get('jwt-login')
			try {
				const response = await this.updateUrlEdit([
					{
						urlM: {...this.url},
						longUrl: this.newUrl
					},
					token
				])
				this.openEdit = true
				if (response.status >= 400) {
          throw new Error(response.data.message)
        }  else {
          this.toaster(
            'URL atualizada com sucesso',
            'var(--green)',
            true
          )
        }
				this.openEdit = false
			} catch (error) {
        this.toaster(error.message, 'red accent-2', true)
      }
		},
		toaster(message, color, visible) {
      this.setToaster({
        message,
        color,
        visible
      })
    },
	},
	watch: {
		'newUrl' () {
			this.newUrl !== ''
			this.disabled = false
		}
	}
}
</script>
<style lang="">
@media screen and (max-width: 1377px) {
	.responsive-note {
		width: 817px
	}
	
	.borderGreen {
		padding-left: 4px;	
	}
	.responsive-input-long {
		width: 500px !important;
	}
	.responsive-input {
		width: 710px !important;
	}
}

</style>


// WEBPACK FOOTER //
// src/components/Contents/UrlTools/ShortnerEdit.vue